import React, { BaseHTMLAttributes, DetailedHTMLProps } from 'react';

import cn from 'classnames';
import './Segment.scss';

type SegmentPropsType = DetailedHTMLProps<
  BaseHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  className?: string;
};

export const Segment = ({ className, children, ...rest }: SegmentPropsType) => {
  return (
    <div className={cn('Segment', className)} {...rest}>
      {children}
    </div>
  );
};
